module.exports = __webpack_public_path__ + "img/practical-go-lessons-book-review-epub.84f583b5.png";